import { render, staticRenderFns } from "./DesignProviderDropdown.vue?vue&type=template&id=bc57a04c&"
import script from "./DesignProviderDropdown.vue?vue&type=script&lang=ts&"
export * from "./DesignProviderDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports